import { DownloadSimple, FloppyDisk, PencilSimple, Sparkle, Trash } from "@phosphor-icons/react";

const base = "flex items-center justify-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-40";

export const MemoryActions = ({ editing, saving, onEdit, onSave, onDelete, onPrint, onInsight, insightLabel = "Memory Insight" }) => (
  <div data-testid="memory-actions" className="grid grid-cols-2 gap-2 border-t border-[#4A4540]/10 pt-4 sm:grid-cols-3">
    <button data-testid="memory-edit-btn" onClick={onEdit} disabled={editing}
      className={`${base} border border-[#2C2A28]/20 bg-white text-[#2C2A28] hover:bg-[#F4EFE6]`}>
      <PencilSimple size={16} /> Edit entry
    </button>
    <button data-testid="memory-save-btn" onClick={onSave} disabled={!editing || saving}
      className={`${base} bg-[#2E3B31] text-white hover:bg-[#25302a]`}>
      <FloppyDisk size={16} /> {saving ? "Saving…" : "Save Changes"}
    </button>
    <button data-testid="memory-delete-btn" onClick={onDelete}
      className={`${base} border border-[#B4412F]/40 bg-white text-[#B4412F] hover:bg-[#FBEDEA]`}>
      <Trash size={16} /> Delete
    </button>
    <button data-testid="memory-print-btn" onClick={onPrint}
      className={`${base} border border-[#2C2A28]/20 bg-white text-[#2C2A28] hover:bg-[#F4EFE6]`}>
      <DownloadSimple size={16} /> Print or Download
    </button>
    <button data-testid="memory-insight-btn" onClick={onInsight}
      className={`${base} col-span-2 bg-[#A84A32] text-white hover:bg-[#8f3e29] sm:col-span-2`}>
      <Sparkle size={16} weight="duotone" /> {insightLabel}
    </button>
  </div>
);
